module.exports = __webpack_public_path__ + "img/shopping-cart-two.7d237df3.svg";